import { Watch, Headphones, Speaker, Gift } from "lucide-react";
import { Reveal } from "./Reveal";
import { PRIZES } from "./data";

const ICONS = { watch: Watch, headphones: Headphones, speaker: Speaker };

export const Doorprize = () => (
    <section id="doorprize" className="bg-[#F8F6F1] py-20 lg:py-28" data-testid="doorprize-section">
        <div className="mx-auto max-w-5xl px-5 lg:px-8">
            <Reveal className="mx-auto max-w-2xl text-center">
                <p className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.22em] text-[#123E65]">
                    <Gift className="h-4 w-4 text-[#DDB56C]" strokeWidth={1.5} /> Doorprize
                </p>
                <h2 className="mt-4 text-3xl font-extrabold tracking-tight text-[#1C2533] sm:text-4xl" data-testid="doorprize-heading">
                    Belajar KPR, Berkesempatan{" "}
                    <span className="font-accent italic text-[#123E65]">Dapat Hadiah Menarik!</span>
                </h2>
                <p className="mt-5 text-base leading-relaxed text-[#1C2533]/75">
                    Selain mendapatkan ilmu dan insight seputar KPR, peserta juga berkesempatan mengikuti program doorprize menarik.
                </p>
            </Reveal>
            <div className="mt-12 grid gap-5 sm:grid-cols-3" data-testid="doorprize-cards">
                {PRIZES.map((p, i) => {
                    const Icon = ICONS[p.icon];
                    return (
                        <Reveal key={p.name} delay={i * 0.1}>
                            <div className="group rounded-2xl border border-[#071B37]/8 bg-white p-8 text-center shadow-[0_8px_32px_rgba(7,27,55,0.06)] transition-all duration-300 hover:-translate-y-2 hover:border-[#DDB56C]/50" data-testid={`doorprize-card-${i + 1}`}>
                                <div className="mx-auto mb-5 inline-flex rounded-full bg-gradient-to-b from-[#123E65] to-[#071B37] p-5">
                                    <Icon className="h-8 w-8 text-[#DDB56C]" strokeWidth={1.25} />
                                </div>
                                <h3 className="text-lg font-bold text-[#1C2533]">{p.name}</h3>
                            </div>
                        </Reveal>
                    );
                })}
            </div>
            <Reveal delay={0.2}>
                <p className="mt-8 text-center text-xs text-[#1C2533]/55 sm:text-sm" data-testid="doorprize-note">
                    Doorprize mengikuti ketentuan penyelenggara. Hadiah tidak dijamin untuk setiap peserta.
                </p>
            </Reveal>
        </div>
    </section>
);
